import { useEffect, lazy, Suspense } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { useCookieList } from 'hb-react/shared/apps/CookieBanner/hooks/useCookieList';
import emitter from 'hb-react/shared/utils/emitter';

import { useConnectAmplitude } from '../hooks/useConnectAmplitude';
import {
  removeNonRequiredCookies,
  acceptRequiredCookies,
} from '../utils/manageRequiredCookies';

const CookieBanner = lazy(() => import('../components/CookieBanner'));

const CookieBannerApp = ({ env }) => {
  const { currentNetwork } = useDefaultAppContexts();

  const { cookieLists } = useCookieList(env);
  const cookieBannerEnabled =
    currentNetwork.features.cookies.config.cookies_banner_v2_enabled;
  const displayCookieAgreement =
    currentNetwork.features.cookies.config.display_cookie_agreement;

  const { connect } = useConnectAmplitude(env);

  useEffect(() => {
    if (cookieBannerEnabled && !displayCookieAgreement) {
      emitter.on('nativeRejectedUserConsent', () => {
        removeNonRequiredCookies(cookieLists);
        acceptRequiredCookies(cookieLists);
      });
    }

    return () => {
      emitter.off('nativeRejectedUserConsent');
    };
  }, [cookieLists, cookieBannerEnabled, displayCookieAgreement]);

  return cookieBannerEnabled && (env === 'bo' || displayCookieAgreement) ? (
    <Suspense fallback={null}>
      <CookieBanner env={env} connectAmplitude={connect} />
    </Suspense>
  ) : null;
};

export default CookieBannerApp;
